<template>
  <button @click="handleExport" type="button" class="inline-flex justify-center w-full rounded-md border border-gray-700 shadow-sm px-4 py-2 bg-gray-800 text-sm font-medium text-white hover:bg-gray-700 focus:outline-none">
    Export
  </button>
</template>

<script setup lang="ts">
const emit = defineEmits(['export-png']);

function handleExport() {
  emit('export-png');
}
</script> 